import React from 'react';

import BaseModal from 'components/WrappedComponents/BaseModal';
import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';

import FormCreate from './FormCreate';

interface ModalCreateProps {
  close: () => void;
  visible: boolean;
  onSuccess: (lastModificationDate: number) => void;
}

export default function ModalCreate({
  close,
  visible,
  onSuccess,
}: ModalCreateProps): React.ReactElement {
  return (
    <BaseModal
      width={BaseModalWidthUtils.largeWidth}
      isVisible={visible}
      closeModal={close}
    >
      <FormCreate close={close} onSuccess={onSuccess} />
    </BaseModal>
  );
}
